import { render, staticRenderFns } from "./OrganizationPacketCreatorGuard.vue?vue&type=template&id=a9e85bc4&"
import script from "./OrganizationPacketCreatorGuard.vue?vue&type=script&lang=ts&"
export * from "./OrganizationPacketCreatorGuard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports